import MegaMenu from './components/MegaMenu';
import Search from './components/Search';
import MobileMenu from './components/MobileMenu';
import TextImageSlider from './components/TextImageSlider';
import Accordions from './components/Accordions';
import PostsSlider from './components/PostsSlider';
import ServicesSlider from './components/ServicesSlider';
import ProductSlider from './components/ProductSlider';
import BannerSlider from './components/BannerSlider';
import MobilePagination from './components/MobilePagination';
import PostCarousel from './components/PostCarousel';
import JobApplicationForm from './components/JobApplicationForm';
import initMap from './components/Map';
import PopUp from './components/PopUp-box';
import LangBar from './components/LangBar';
import FlexibleMap from './components/FlexibleMap';

import '@fancyapps/fancybox';

{
  Search();
  MobileMenu();
  TextImageSlider();
  PostsSlider();
  ServicesSlider();
  ProductSlider();
  BannerSlider();
  PostCarousel();
  LangBar();
}

{
  const map = document.querySelector('.map');

  if (typeof map != 'undefined' && map) {
    FlexibleMap();
  }
}

let popupblock = document.querySelector('.pop-up');
if (typeof popupblock != "undefined" && popupblock != null) {
  PopUp();
}

let ACFmap = document.querySelector('.acf-map');
if (typeof ACFmap != "undefined" && ACFmap != null) {
  initMap();
}

{
 let nav = document.querySelector('.nav-lower');
 if (typeof nav != "undefined" && nav != null) {
   MegaMenu();
 }
}

{
  let accordions = document.querySelector('.accordions');

  if (typeof accordions != 'undefined' && accordions != null) {
    Accordions();
  }
}

{
  let pagination = document.querySelector('.news-pagination');

  if (typeof pagination != 'undefined' && pagination != null) {
    MobilePagination();
  }
}

{
  let form = document.querySelector('.gform_body');

  if (typeof form != 'undefined' && form != null) {
    JobApplicationForm();
  }
}



// WEBPACK FOOTER //
// ./src/js/app/index.js